import { formatNumberWithSpaces } from 'utils/numbers';
import './brokerAlert.css';

const BrokerAlert = ({ exante, lmax, isAdmin }) => {

  const AlertCard = ({ amount, threshold, label, pendingLabel, pendingAmount }) => {
    const isSufficient = amount > Number(threshold);
    return (
      <div className={`broker_alert_box ${isSufficient ? '' : 'un'}sufficient_amount`}>
        <div className='broker_alert_icon'>
          {isSufficient ? '✓' : '!'}
        </div>
        <div className='broker_alert_box_text'>
          <span><strong>{label}</strong> : {formatNumberWithSpaces(amount)} €</span>
          {pendingAmount !== undefined && (
            <span style={{opacity: 0.75, fontSize: '12px'}}>dont {formatNumberWithSpaces(pendingAmount)} € {pendingLabel}</span>
          )}
        </div>
      </div>
    );
  };

  const getAlert = (exante, lmax) => (
    <div className='broker_main_div'>
      {exante?.tradesAvailable ? (
        <div className='broker_div'>
          <h3 className='broker_name_title'>EXANTE</h3>
          <AlertCard
            amount={exante.tradesAvailable}
            threshold={process.env.REACT_APP_EXANTE_ALERT_THRESHOLD}
            label="Compte trades"
            pendingLabel="d'achat limit"
            pendingAmount={exante.pendingBuy}
          />
          <AlertCard
            amount={exante.marginAvailable}
            threshold={process.env.REACT_APP_EXANTE_ALERT_MARGIN_THRESHOLD}
            label="Compte margin"
            pendingLabel="d'achat limit"
            pendingAmount={exante.pendingLimitBuy}
          />
          <AlertCard
            amount={exante.shortingAvailable}
            threshold={process.env.REACT_APP_EXANTE_ALERT_SHORTING_THRESHOLD}
            label="Compte shorting"
            pendingLabel="d'achat limit"
            pendingAmount={exante.pendingLimitShort}
          />
        </div>
      ) : (
        <div className='broker_div'>
          <h3 className='broker_name_title'>EXANTE</h3>
          <div className='broker_alert_box unsufficient_amount'>
            <div className='broker_alert_icon'>!</div>
            <div className='broker_alert_box_text'>
              <span>L'argent disponible n'a pas pu être récupéré sur Exante</span>
            </div>
          </div>
        </div>
      )}
      {lmax.marginAvailable ? (
        <div className='broker_div'>
          <h3 className='broker_name_title'>LMAX</h3>
          <AlertCard
            amount={lmax.marginAvailable}
            threshold={process.env.REACT_APP_LMAX_ALERT_THRESHOLD}
            label="Compte LONG"
            pendingLabel="d'achat limit"
            pendingAmount={lmax.pendingLong}
          />
          <AlertCard
            amount={lmax.shortingAvailable}
            threshold={process.env.REACT_APP_LMAX_ALERT_THRESHOLD}
            label="Compte SHORT"
            pendingLabel="d'achat limit"
            pendingAmount={lmax.pendingShort}
          />
        </div>
      ) : (
        <div className='broker_div'>
          <h3 className='broker_name_title'>LMAX</h3>
          <div className='broker_alert_box unsufficient_amount'>
            <div className='broker_alert_icon'>!</div>
            <div className='broker_alert_box_text'>
              <span>L'argent disponible n'a pas pu être récupéré sur LMAX</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  return isAdmin && (getAlert(exante, lmax));
}

export default BrokerAlert